import { styled } from '@mui/material/styles'
import { DataGrid, gridClasses } from '@mui/x-data-grid'

export const DataGridCustom = styled(DataGrid)(({ theme }) => ({
  [`& .${gridClasses.columnHeaders}`]: {
    backgroundColor: theme.palette.info.main,
    color: theme.palette.common.white,
  },
  [`& .${gridClasses.columnSeparator}`]: {
    display: 'none',
  },
  [`& .${gridClasses.root}`]: {
    display: 'none',
  },
}))
